// extracted by mini-css-extract-plugin
export default {"container":"CtaAVxmX","inContent":"VoPTLAWw","mobile":"mobile","fullscreen":"tWfi05oS","totalCount":"XxCg8fQ0","count":"Gdh6YdSL"};